import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout"; // Import MainLayout
import { ModeProvider } from "./contexts/ModeContext"; // Import ModeProvider
import { EntityProvider } from "./contexts/EntityContext"; // Import EntityProvider
import { PortfolioConfigProvider } from "./contexts/PortfolioConfigContext"; // Import PortfolioConfigProvider

// Importa tus componentes de página
import DashboardPage from "./pages/DashboardPage";
import NotesPage from "./pages/NotesPage";
import TasksPage from "./pages/TasksPage";
import UpdatesPage from "./pages/UpdatesPage";
import EmailPage from "./pages/EmailPage";
import ChatbotPage from "./pages/ChatbotPage";
import PersonalDashboard from "./pages/Finance/PersonalDashboard"; // Use PersonalDashboard
import DesignShowcasePage from "./pages/DesignShowcasePage";
import PortfolioPage from "./pages/Finance/PortfolioPage";
import NewsVideosPage from "./pages/NewsVideosPage";
import CalendarTasksPage from "./pages/CalendarTasksPage";
import N8NMonitorPage from "./pages/N8NMonitorPage";
import DataIngestionPage from "./pages/DataIngestion/DataIngestionPage"; // Import DataIngestionPage
import RitualsPage from "./pages/RitualsPage";
import JournalPage from "./pages/JournalPage";
import SettingsPage from "./pages/SettingsPage";
import HealthDashboardPage from "./pages/Health/HealthDashboardPage";
// Import the new auth pages
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
// Import ProtectedRoute
import ProtectedRoute from "./components/ProtectedRoute";
// Podrías añadir un componente NotFoundPage aquí también
// import NotFoundPage from './pages/NotFoundPage';

import "./styles/theme.css";
import "./styles/index.css";

function App() {
  return (
    <ModeProvider>
      {" "}
      {/* Wrap entire app with ModeProvider for global mode state */}
      <EntityProvider>
        {" "}
        {/* Wrap with EntityProvider for entity management */}
        <PortfolioConfigProvider>
          {" "}
          {/* Wrap with PortfolioConfigProvider for portfolio configuration */}
          <BrowserRouter>
            <MainLayout>
              {" "}
              {/* Wrap Routes with MainLayout */}
              <Routes>
                {/* Auth Routes (Public) */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />

                {/* Protected Routes */}
                <Route
                  path="/design-showcase"
                  element={
                    <ProtectedRoute>
                      <DesignShowcasePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notes"
                  element={
                    <ProtectedRoute>
                      <NotesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/tasks"
                  element={
                    <ProtectedRoute>
                      <TasksPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/updates"
                  element={
                    <ProtectedRoute>
                      <UpdatesPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/email"
                  element={
                    <ProtectedRoute>
                      <EmailPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/chatbot"
                  element={
                    <ProtectedRoute>
                      <ChatbotPage />
                    </ProtectedRoute>
                  }
                />
                {/* Finance Routes - Mode-based routing will be implemented here */}
                <Route
                  path="/finance"
                  element={
                    <ProtectedRoute>
                      <PersonalDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/finance/portfolio"
                  element={
                    <ProtectedRoute>
                      <PortfolioPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/news"
                  element={
                    <ProtectedRoute>
                      <NewsVideosPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/calendar"
                  element={
                    <ProtectedRoute>
                      <CalendarTasksPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/n8n-monitor"
                  element={
                    <ProtectedRoute>
                      <N8NMonitorPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/data-ingestion"
                  element={
                    <ProtectedRoute>
                      <DataIngestionPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/rituals"
                  element={
                    <ProtectedRoute>
                      <RitualsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/journal"
                  element={
                    <ProtectedRoute>
                      <JournalPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/health"
                  element={
                    <ProtectedRoute>
                      <HealthDashboardPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute>
                      <SettingsPage />
                    </ProtectedRoute>
                  }
                />

                {/* Ruta para página no encontrada (Opcional pero recomendado) */}
                {/* <Route path="*" element={<NotFoundPage />} /> */}
              </Routes>
            </MainLayout>
          </BrowserRouter>
        </PortfolioConfigProvider>
      </EntityProvider>
    </ModeProvider>
  );
}

export default App;
